<template>
    <window :title="title">
        <template v-if="!display.mobile.value">
            <img
                :src="`/cedu/images/intro/slidepc.PNG`"
                class="w-65 d-block mx-auto mt-3"
            />
        </template>
        <template v-if="display.mobile.value">
            <span>※横画面表示の場合</span>
            <img
                :src="`/cedu/images/intro/slidem.PNG`"
                class="w-100 d-block mx-auto mt-3"
            />
        </template>
        <br />
        <div class="text-center mt-3">
            <router-link class="btn btn-primary" :to="`/base/${contentsName}`"
                >学習を開始する
            </router-link>
        </div>
    </window>
</template>

<script>
import { useDisplay } from "vuetify/lib/composables/display";

export default {
    name: "intro",
    setup() {
        const display = useDisplay();
        return { display };
    },
    data() {
        return {
            title: "学習画面説明ページ",
            contentsName: this.$route.params.contents,
        };
    },
};
</script>